// extracted by mini-css-extract-plugin
export default {"title":"styles_title__X0NCR","small":"styles_small__J2C9R","thin":"styles_thin__2twBc"};